export const INSTALLED_APPS_STORAGE_KEY = 'installed-apps-show-more';
export const SHOW_MORE_APPS_TEST_ID = 'show-more-apps';
export const SHOW_LESS_APPS_TEST_ID = 'show-less-apps';
